module.exports = "../../app/cells/components/preparation_guide_cell.rb";